import { Action } from '@ngrx/store';
import {
    ActionOptionsArgs,
    BaseAction,
    PersistableAction,
    SynchronisableAction
} from '../../../core/store/actions/base-actions';
import { Job } from './job.model';
import { IJobFilters } from './job.reducer';

export const ENTITY = 'job';
export const SUBMIT = '[Job] Submit';
export const REMOVE = '[Job] Remove';
export const BUMP_VERSION = '[Job] Bump Version';
export const LOAD_NEXT_PAGE = '[Job] Load Next Page';
export const REHYDRATE = '[Job] Rehydrate';
export const RESET_FILTER_DEFAULTS_FLAG = '[Job] Reset Filter Defaults Flag';
export const RESET_OFFSET = '[Job] Reset Offset';
export const SET_FILTER = '[Job] Set Filter';
export const SET_TOTAL = '[Job] Set Total';
export const SET_UI_LOADING = '[Job] Set UI Loading';
export const SYNC_JOBS = '[Job] Sync Jobs';
export const SYNC_JOBS_ENQUEUE = '[Job] Sync Jobs Enqueue';
export const UPDATE_FROM_API = '[Job] Update From API';
export const WIPE = '[Job] Wipe All';

export class SubmitAction extends SynchronisableAction {
    readonly entity = ENTITY;
    readonly type = SUBMIT;

    constructor(public payload: Job, options?: ActionOptionsArgs) {
        super(payload, options);
    }

    getKey(): string {
        return `${this.entity}:entity:${this.payload.id}`;
    }
}

export class RemoveAction extends SynchronisableAction {
    readonly type = REMOVE;
    readonly entity = ENTITY;

    constructor(public payload: Job, options?: ActionOptionsArgs) {
        super(payload, options);
    }

    getKey(): string {
        return `${this.entity}:entity:${this.payload.id}`;
    }
}

export class SetFilterAction extends PersistableAction {
    readonly type = SET_FILTER;
    readonly entity = ENTITY;

    constructor(public payload: IJobFilters, options?: ActionOptionsArgs) {
        super(payload, options);
    }

    getKey(): string {
        return `${this.entity}:filters`;
    }
}

export class SetTotalAction extends BaseAction {
    readonly type = SET_TOTAL;
    readonly entity = ENTITY;

    constructor(public payload: number, options?: ActionOptionsArgs) {
        super(payload, options);
    }
}

export class LoadNextPage extends BaseAction {
    readonly type = LOAD_NEXT_PAGE;
    readonly entity = ENTITY;

    constructor() {
        super(undefined);
    }
}

export class SetUiLoading extends BaseAction {
    readonly type = SET_UI_LOADING;
    readonly entity = ENTITY;

    constructor(public value: boolean) {
        super(value);
    }
}

export class SyncJobsEnqueueAction implements Action {
    readonly type = SYNC_JOBS_ENQUEUE;
}

export class SyncJobsAction implements Action {
    readonly type = SYNC_JOBS;
}

export class BumpVersionAction implements Action {
    readonly type = BUMP_VERSION;

    constructor(public payload: string) {

    }
}

export class Rehydrate implements Action {
    readonly type = REHYDRATE;

    constructor(public payload: Array<Job>) {

    }
}

export class ResetFilterDefaultsFlagAction implements Action {
    readonly type = RESET_FILTER_DEFAULTS_FLAG;
}

export class ResetOffsetAction implements Action {
    readonly type = RESET_OFFSET;
}

export class UpdateFromApi implements Action {
    readonly type = UPDATE_FROM_API;

    constructor(public payload: {jobs: Array<Job>}) {

    }
}

export class WipeAction implements Action {
    readonly type = WIPE;
}

export type Actions
    = BumpVersionAction
    | LoadNextPage
    | Rehydrate
    | RemoveAction
    | ResetFilterDefaultsFlagAction
    | ResetOffsetAction
    | SetFilterAction
    | SetTotalAction
    | SetUiLoading
    | SubmitAction
    | UpdateFromApi
    | WipeAction
    ;



// WEBPACK FOOTER //
// ./src/vas/business-objects/job/job.actions.ts